import posthog from 'posthog-js';

// @ts-ignore
const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
// @ts-ignore
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? 'https://eu.i.posthog.com';
// @ts-ignore
const APP_VERSION = import.meta.env.VITE_APP_VERSION;

function getEnvironment() {
  // eslint-disable-next-line no-restricted-globals
  if (window.location.hostname.includes('portal.stag')) {
    return 'staging';
    // eslint-disable-next-line no-restricted-globals
  } else if (window.location.hostname.includes('ngrok.io') || window.location.hostname.includes('localhost')) {
    return 'development';
  } else {
    return 'production';
  }
}

if (!POSTHOG_KEY) {
  console.warn('PostHog key not provided, skipping PostHog initialization');
} else {
  console.info(`Initializing PostHog for environment: ${getEnvironment()}`);

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: 'history_change',
    capture_pageleave: true,
    person_profiles: 'identified_only',
    loaded: (ph) => {
      ph.register({
        environment: getEnvironment(),
        app_version: APP_VERSION ?? 'dev',
      });
    },
  });
}

export { posthog };
